const dropContainer = {
  scheduledServiceTitle: 'Scheduled Service',
  scheduledServicesTitle: 'Scheduled Services',
  scheduledServiceDoneTitle: 'Service Done',
  scheduledServicesDoneTitle: 'Services Done',
};

export default dropContainer;
